var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ViewContainer',{staticClass:"view-unlock-code main-content virtual-player-view"},[_c('google-model-viewer',{staticClass:"full-screen",attrs:{"gltf":_vm.currentGLTFUrl[0],"iosSrc":_vm.currentGLTFUrl[1]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }